@if (hasViewPermission || hasEditPermission) {
    <div class="card panel-flat-color secondary-panel">
        <div class="panel-flat-header" (click)="expandOrCollapse()" [ngClass]="{'pointer': !isEditMode}">
            <panel-chevron [showBody]="showBody"></panel-chevron>
            <h3>Contract Terms</h3>
            <div class="float-end header-button-container" (click)="$event.stopPropagation()">
                @if (showBody) {
                    <div style="display: inline-block; vertical-align: middle; margin-top: -5px; margin-right: 30px;">
                        <span style="margin-right: 5px;">Tax Year:</span>
                        <select (ngModelChange)="yearChanged($event)"
                                [(ngModel)]="selectedYear"
                                class="form-select form-select-sm"
                                style="display: inline-block; width: auto;">
                            <option value="0">All</option>
                            @for (year of contractTermYears; track year) {
                                <option [value]="year">{{ year }}</option>
                            }
                        </select>
                    </div>
                }
                @if (!isEditMode && showBody && hasEditPermission && entity.hasWritePermission) {
                    <button class="ace-btn btn-text has-icon btn-primary" (click)="goToEditMode()">
                        <i class="fa fa-pencil"></i>
                    </button>
                }
                @if (isEditMode && showBody) {
                    <div style="display: inline-block; vertical-align: middle;">
                        <button class="ace-btn btn-text has-icon btn-primary btn-success"
                                (click)="savePanel()"
                                [disabled]="isLoading">
                            <i class="fa fa-save"></i>
                        </button>
                        <button class="ace-btn btn-text has-icon btn-primary btn-danger" (click)="cancelEdit()">
                            <i class="fa fa-close"></i>
                        </button>
                    </div>
                }
            </div>
        </div>
        @if (showBody) {
            <div class="card-body" style="padding-top: 0;">
                @if (isLoading) {
                    <div class="text-center" style="margin-top: 50px;">
                        <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
                    </div>
                }
                @if (!isLoading) {
                    <div>
                        <table class="table table-condensed contract-terms-site">
                            <thead>
                                <tr>
                                    <th>Service</th>
                                    <th>Property Type</th>
                                    <th class="text-center">Tax Year</th>
                                    <th>Terms</th>
                                    <th class="text-center">Engagement #</th>
                                </tr>
                            </thead>
                            <tbody class="contract-terms-view">
                                @for (term of contractTerms; track term) {
                                    <tr>
                                        <td>{{ term.service }}</td>
                                        <td>{{ term.propertyType }}</td>
                                        <td class="text-center">{{ term.taxYear }}</td>
                                        <td>
                                            @if (!isEditMode && !term.currentTermItem) {
                                                <div [class.not-site-default]="isTermNotSiteDefault(term)">N/A</div>
                                            }
                                            @if (!isEditMode && term.currentTermItem) {
                                                <div
                                                    class="d-flex justify-content-between"
                                                    [class.not-site-default]="isTermNotSiteDefault(term)">
                                                    <term-rates-and-fees [term]="term.currentTermItem"
                                                                         [usePercent]="true"></term-rates-and-fees>
                                                    @if (term.currentTermItem && term.currentTermItem.remarks) {
                                                        <button
                                                            class="ace-btn has-icon btn-primary"
                                                            (click)="showComments(term)"
                                                            style="margin-left:0.5em;"
                                                            [title]="term.currentTermItem.remarks">
                                                            <i class="fa fa-commenting"></i>
                                                        </button>
                                                    }
                                                </div>
                                            }
                                            @if (isEditMode) {
                                                <select [(ngModel)]="term.currentTermItem"
                                                        class="form-select form-select-sm"
                                                        [class.not-site-default]="isTermNotSiteDefault(term)">
                                                    <option [ngValue]="null"
                                                            [ngStyle]="{'color': term.companySiteDefaultTermId ? 'red' : 'black'}">
                                                        N/A
                                                    </option>
                                                    @for (item of term.availableTermItems; track item) {
                                                        <option [ngValue]="item"
                                                                [ngStyle]="{'color': item.termDetailId === term.companySiteDefaultTermId ? 'black' : 'red'}">
                                                            <term-rates-and-fees [term]="item"
                                                                                 [usePercent]="true"></term-rates-and-fees>
                                                        </option>
                                                    }
                                                </select>
                                            }
                                            @if (isEditMode && term.currentTermItem && term.currentTermItem.remarks) {
                                                <button
                                                    class="ace-btn has-icon btn-primary"
                                                    (click)="showComments(term)"
                                                    style="margin-left:0.5em;"
                                                    [title]="term.currentTermItem.remarks">
                                                    <i class="fa fa-commenting"></i>
                                                </button>
                                            }
                                        </td>
                                        <td class="text-center">
                                            @if (term.currentTermItem) {
                                                <span>{{ term.currentTermItem.engagement }}</span>
                                            }
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        }
    </div>
}
